const domaine = 'DROITS_ACTIONS'

export const AJOUTER_DROITS_ACTIONS = `${domaine}/AJOUTER_DROITS_ACTIONS`
export const AJOUTER_DROITS_STOCK = `${domaine}/AJOUTER_DROITS_STOCK`
